export const driveImageUrl = (id: string) => `https://lh3.googleusercontent.com/d/${id}`;

export const MEDIA_ASSETS = {
  logo: '/logo.png',
  supHero: '/SUP-tour.jpg',
  supHeroVideo: '/water-adventures-preview.mov',
  bikeHero:
    'https://images.unsplash.com/photo-1541625602330-2277a4c46182?q=80&w=2400&auto=format&fit=crop',
  routeKaracagoren: encodeURI('/PHOTO-2026-02-25-03-47-25.jpg'),
  routeBeachparkLara: encodeURI('/Kondisyon Rotası K-Lara Balık (1).png'),
  routeBeachpark: encodeURI('/Konyaaltı Rotası (1).jpg'),
  routeDuden: encodeURI('/Lara Düden Rota.jpg'),
  supGalleryA: driveImageUrl('1_PS3KdAhQe8p6dXtxJ2yNEMHT9DvPp-R'),
  supGalleryB: driveImageUrl('1COxd_ojMEjpyNVJNqyqUzzLebzO2i4Lr'),
  shopMain: driveImageUrl('11ZZkfgtn_1Np7wEMvzMwwWOIcmU29VAX')
};
